module.exports = __webpack_public_path__ + "img/carbon3.0d9b16df.png";